import Crud from '../views/ItemChecklist/Crud'
import Entity from '../views/ItemChecklist/Add'

let routes = {
    path: '/itemchecklists',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/itemchecklists/add',
            name: 'NewCbo',
            component: Entity
        },
        {
            path: '/itemchecklists/edit/:id?',
            name: 'EditCbo',
            component: Entity
        },
        {
            path: '/itemchecklists',
            name: 'list-itemchecklists',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Item de Checklists',
                breadcrumb: [
                    {
                        text: 'Item Checklists',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
